import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed bottom-0 left-0 right-0 bg-gray-900 text-white z-50 shadow-lg"
}
const _hoisted_2 = { class: "max-w-6xl mx-auto px-4 py-4 flex flex-col sm:flex-row items-start sm:items-center gap-4" }
const _hoisted_3 = { class: "flex-1" }
const _hoisted_4 = { class: "text-sm" }
const _hoisted_5 = {
  href: "/cookie-policy",
  class: "text-xs text-blue-300 hover:underline"
}
const _hoisted_6 = { class: "flex gap-2 shrink-0" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($setup.visible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", _hoisted_4, _toDisplayString($setup.t('cookies.message')), 1 /* TEXT */),
            _createElementVNode("a", _hoisted_5, _toDisplayString($setup.t('cookies.learn_more')), 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
              onClick: $setup.acceptAll,
              class: "px-4 py-2 text-sm font-medium bg-blue-600 text-white rounded-lg hover:bg-blue-500 transition"
            }, _toDisplayString($setup.t('cookies.accept_all')), 1 /* TEXT */),
            _createElementVNode("button", {
              onClick: $setup.acceptEssential,
              class: "px-4 py-2 text-sm font-medium bg-gray-700 text-gray-200 rounded-lg hover:bg-gray-600 transition"
            }, _toDisplayString($setup.t('cookies.essential_only')), 1 /* TEXT */)
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}